/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import moment from "moment";

import {
  getCompanyList,
  setFinanceContract,
  getFinanceContractInfoById,
  getCustomerList,
  getFinanceContractTemplate,
  getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId,
  getProjectList,
  getFinancOrder,
  generatePdf,
  setFinanceContractByIdAndTypes,
} from "@/api/financial-center";

import { formatDate } from "@/utils/timeFilter";
import { menuBtn } from "@/utils/menu_level2_button";

import { delNullProperty } from "@/utils";

import {
  Customer,
  Project,
} from "@/views/financial-center/order/new-ordinary-order/interface";
import * as math from "mathjs";
import md5 from "js-md5";

import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";
import axios from "axios";

Vue.directive("el-select-loadmore1", {
  // 指令懒加载
  // bind表示这个自定义指令一绑定到dom上，就开始自动执行
  bind(el: any, binding: any) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector(
      ".el-select-dropdown .el-select-dropdown__wrap",
    );
    SELECTWRAP_DOM.addEventListener("scroll", function () {
      /**
       * scrollHeight 获取元素内容高度(只读)
       * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
       * clientHeight 读取元素的可见高度(只读)
       * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
       * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
       */
      const condition =
        this.scrollHeight - this.scrollTop - 1 <= this.clientHeight;
      if (condition) {
        binding.value();
      }
    });
  },
  // 表示dom插入到页面上的时候自动执行
  // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
  inserted(el, binding) {
    el.focus();
  },
  // 表示自定义指令后面的值更新的时候，自动执行
  update() {
    // console.log(this.scrollHeight , this.scrollTop, '11');
  },
});

@Component({
  components: {
    MoreUsersFilter,
  },
})
export default class ContractAddAgent extends Vue {
  limit = 20;
  tableKey = Math.random();
  orderList = [];
  orderDialogSelect: any = [];

  studentDialog = false;
  studentDialogInputValue = "";
  studentDialogTaleData = [];
  studentDialogTotal = 0;
  studentDialogPage = 1;
  orderDialogFilterTotal = 0;
  studentDialogTableLoading = false;
  studentConfirmList = {
    name: "",
    id: "",
    customerId: null,
  };
  studentDialogSelect = {
    name: "",
    id: "",

    customerId: NaN,
  };

  tableData = [];
  formData = {
    directorUserId: "",
    deparmentId: "",
    deparment: "",
    company: "",
    contractAt: null,
    customerId: null,
    marketCooperationId: null,
    // customerOrParternerName: '', // 新加的

    isAdult: "1", //客户是否成年
    // souCourseType: '',//项目类型
    souCourseSchoolBegin: "", // 开课时间
    projectAllId: "", // 项目id
    // isDoubleSouCourseName: '', //是否是双课题备注
    souCoursePrice: "", // 项目价格
    souCourseName: "", //项目名称
    customerName: "", // 客户名称
    dissertationType: "", // 论文服务类型
    priceOrRatio: "", // 结算价或返点比例
    commissionType: "", // 佣金类型
    companyName: "", // 所属公司
    financeOrderCode: "", //订单编号
    contractTemplateName: null,
    custodianName: "", // 监护人
    custodianIdCard: "",
    custodianPhone: "",
    // psnName: '', //签署方姓名
    psnAccount: "", //签署方姓名
    idCard: "", //签署方身份证
    souCourseType: "", // 项目类型
    contractUrl: "",
    sourceType: "", // 客户来源
    source: "", // 客户具体来源
    discountPrice: 0, // 优惠金额
    directorUserName: "",
  };
  intentionProjectSelected = []; //选中的意向项目列表
  projectDialogCheckedTable: Project = {
    souTeacherName: "",
    souTeacherSchool: "", // 导师学校
    projectAllId: null,
    souCourseIndex: "",
    souCourseName: "",
    souCoursePrice: "",
    souCourseSchoolBegin: "",
    souCourseType: "",
    status: "",
    surplusQuota: null,
    radio: "", //是否展示双课题备注
    // doubleSouCourseName: '', //双课题备注
    souCourseNameTwo: "", //专业选修课
    isHaveDissertation: "",
  };

  companyList = [];

  moneyCertificatesArr = [];
  fileList = [];

  disabledButton = false;
  // saveDraftDialogShow = false
  errorDialogShow = false;
  isDraft = "0";

  backMoneyId: number = null;
  orderId: number = null;
  editUserName = ""; // 编辑的时候使用
  editCreatedAt: Date = null; // 编辑的时候用来返显
  draftId: number = null; // 草稿id
  backMoneyStatus = "";
  name = ""; //开户名称
  formRule = {
    customerName: [
      { required: true, message: "请选择客户名称", trigger: "change" },
    ],
    psnAccount: [
      { required: true, message: "请输入客户手机号", trigger: ["blur"] },
    ],
    // idCard: [{required: true, message: '请输入客户身份证号', trigger: ['change', 'blur']}],
    // souCourseType: [{required: true, message: '请选择项目类型', trigger: 'change'}],
    // souCourseSchoolBegin: [{required: true, message: '请选择开课时间', trigger: 'change'}],
    souCourseName: [
      {
        required: true,
        message: "请选择项目名称",
        trigger: ["change", "blur"],
      },
    ],
    souCoursePrice: [
      { required: true, message: "请选择项目价格", trigger: "change" },
    ],
    dissertationType: [
      { required: true, message: "请选择论文服务类型", trigger: "change" },
    ],
    company: [{ required: true, message: "请选择所属公司", trigger: "change" }],
    contractAt: [
      {
        required: true,
        message: "请选择合同签订期限",
        trigger: ["change", "blur"],
      },
    ],
    isAdult: [
      {
        required: true,
        message: "请选择是否成年",
        trigger: ["change", "blur"],
      },
    ],
    custodianName: [
      { required: true, message: "请输入监护人", trigger: "blur" },
    ],
    // custodianIdCard: [{required: true, message: '请输入监护人身份', trigger: 'blur'}],
    custodianPhone: [
      { required: true, message: "请输入监护人手机号", trigger: "blur" },
    ],
    discountPrice: [
      { required: true, message: "请输入优惠金额", trigger: "blur" },
    ],
    contractTemplateName: [
      {
        required: true,
        message: "请选择合同模板",
        trigger: ["change", "blur"],
      },
    ],
    psnAccount1: [
      {
        required: false,
        message: "请输入客户手机号",
        trigger: ["change", "blur"],
      },
    ],
  };
  total: 0;
  contractId = null;
  authorizeUserInfoUrl = "";
  windowsOpen = {};
  windowsOpenLoop = null;
  certCompanyShow = false;
  certPersonalShow = false;
  authorizeUserInfoCompanyUrl = "";
  title = null;
  // psnAccount = null
  customerList = [];
  customerNameLimit = 20;
  customerName = ""; //客户名称
  customerListLoading = false;
  marketCooperationIdListIsLoading = false;
  // marketCooperationId?: number = null
  marketCooperationIdList = []; // 关联上级数据
  marketLevelPage = 1;
  marketLevelSize = 20;
  cooperativePartnerName = "";
  marketCooperationName = "";
  // customerId = null
  customerType = "";
  file = null;
  link = "";
  linkShow = false;
  recordId = null;
  url = "";
  contractCode = "";
  contractOpenUrl = "";
  isReplace = false;
  previewName = "";
  previewVisible = false;
  previewPath = "";
  directorUserId = "";
  contractLoading = false;
  typeList = commonData.projectTypeArray;
  souCoursePriceList = [];
  dialogProjectInputValue = "";
  timer = null;
  projectDialogTableData = [];
  projectDialogTableLoading = false;
  dialogProjectPage = 1;
  dialogProjectTotal = 0;
  dialogProjectLimit = 20;
  projectDialogShow = false;
  customerInfo: Customer = {
    customerId: undefined,
    customerName: "",
    customerSource: "",
    customerSourceType: "",
    customerType: "",
    marketCooperationId: undefined,
  };
  contractTemplateList = [];
  contractTemplateDetail = null;
  types = "0";
  isOrder = false; // 是否有订单，默认没有
  projectDisabled = false;
  address = ""; // 生成合同用 地址
  code = ""; // 统一社会信用代码
  contractUrl = ""; //合同签章
  onlyVal = false;
  formLoading = false;
  editHtml = "";
  souCourseSchoolBegin = null; // 开课时间
  areaNo = "+86";
  custodianAreaNo = "+86";
  jsonData = [];
  priceOrRatioList = "";
  templateRemark = "";
  accountObj: any = {};
  isReadonly = false;
  batchSign = false;
  contractDetail = "";
  isReadonlyproject = false;
  customerNames = null;
  requestDataList = [];
  directorUserPhone = "";
  isAbled = false;
  currentYear = new Date().getFullYear();
  isSyncIEPQ = false;
  axios: any = null;
  pushHtmlStr = "";
  isShowIEPQBtn = false;
  customNo = null;

  menuBtn = menuBtn;

  @Watch("requestDataList", { immediate: true })
  handleRequestDataLists() {
    if (
      this.batchSignInfoData &&
      this.requestDataList.length === this.batchSignInfoData.length
    ) {
      if (this.requestDataList.every((item) => item !== -1)) {
        this.disabledButton = false;
        this.formLoading = false;
        this.$message.success("合同批量签署成功");
        setTimeout(() => {
          this.closePage();
        }, 1000);
      } else {
        this.disabledButton = false;
        this.formLoading = false;
        this.$message.error("合同批量签署未全部成功!!");
      }
    }
  }

  get userName() {
    return UserModule.userName;
  }

  get department() {
    return UserModule.department;
  }

  get userId() {
    return UserModule.userId;
  }

  get userPhone() {
    return UserModule.userPhone;
  }

  get handletimeBegin() {
    let str = "";
    if (
      !this.formData.souCourseSchoolBegin ||
      this.formData.souCourseSchoolBegin.length === 0 ||
      this.formData.souCourseSchoolBegin == "暂未设置开课时间"
    ) {
      str = "";
    } else {
      str =
        formatDate(
          "yyyy-MM-dd",
          new Date(this.formData.souCourseSchoolBegin[0]),
        ) +
        "/" +
        formatDate(
          "yyyy-MM-dd",
          new Date(this.formData.souCourseSchoolBegin[1]),
        );
    }
    return str;
  }

  get batchSignInfoData() {
    /*本地存储中取数据*/
    return JSON.parse(localStorage.getItem("batchSignInfoData"));
  }

  get orderPrice() {
    let price = 0;
    if (this.formData.commissionType == "1") {
      price = math.number(
        math.subtract(
          math.bignumber(Number(this.formData.priceOrRatio)),
          math.bignumber(Number(this.formData.discountPrice)),
        ),
      );
    } else {
      price = math.number(
        math.subtract(
          math.bignumber(Number(this.formData.souCoursePrice)),
          math.bignumber(Number(this.formData.discountPrice)),
        ),
      );
    }
    return price;
  }

  created() {
    this.getCompanyList();

    if (this.$route.query.contractId) {
      this.contractId = Number(this.$route.query.contractId);
      this.getFinanceContractInfoById();
    }
    /*
     * 如果是从报名学员列表过来的*/
    if(this.$route.query.isClassStudent == "true"){
      this.isShowIEPQBtn = true
      this.customNo = this.$route.query.customerCode
    }
    this.formData.customerName = this.$route.query.customerName as any;
    this.formData.customerId = Number(this.$route.query.customerId);
    this.formData.sourceType = String(this.$route.query.customerSourceType); // 客户来源 0 / 1
    this.formData.source = this.$route.query.customerSource
      ? decodeURIComponent(this.$route.query.customerSource as any)
      : ""; // 客户具体来源
    if (this.$route.query.directorUserId) {
      this.formData.dissertationType = "无";
      this.formData.contractAt = [
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ];
      this.formData.directorUserId = this.$route.query.directorUserId as any; // 负责人id
      this.formData.directorUserName = this.$route.query
        .directorUserRealName as any; // 负责人
      this.directorUserPhone = this.$route.query.directorUserPhone as any; // 负责人手机号
      this.formData.deparment = this.$route.query
        .directorDepartmentlName as any; // 负责人部门
    }

    //  如果是从总项目或者班级报名学员过来的时候不调用
    if (!this.formData.customerId) {
      this.getCustomerList(); //学生
    }
    this.customerInfo = {
      customerId: Number(this.$route.query.customerId),
      customerName: this.$route.query.customerName as any,
      customerSource: String(
        decodeURI(this.$route.query.customerSource as any),
      ),
      customerSourceType:
        this.$route.query.customerSourceType == "合作伙伴" ? "1" : "0",
      customerType: this.$route.query.customerType as any,
      marketCooperationId: Number(this.$route.query.marketCooperationId as any),
    };

    this.batchSign = this.$route.query.batchSign as any;
    if (this.batchSign) {
      this.customerNames = this.batchSignInfoData[0].customerId; //默认选中第一个学生
      this.formData.customerName = this.batchSignInfoData[0].customerName; //默认选中第一个学生
      this.formData.customerId = this.batchSignInfoData[0].customerId;
      this.formData.source = this.batchSignInfoData[0].customerSource;
      this.formData.isAdult =
        this.batchSignInfoData[0].isAdult == "是" ? "1" : "0";
      this.formData.idCard = this.batchSignInfoData[0].idCard;
      this.formData.psnAccount = this.batchSignInfoData[0].psnAccount
        ? String(this.batchSignInfoData[0].psnAccount)
        : "";
      this.formData.sourceType = this.batchSignInfoData[0].customerSourceType;
      this.formData.directorUserId = this.batchSignInfoData[0].directorUserId;
      if (this.formData.isAdult == "0") {
        this.formData.custodianName = this.batchSignInfoData[0].custodianName;
        this.formData.custodianIdCard =
          this.batchSignInfoData[0].custodianIdCard;
        this.formData.custodianPhone = this.batchSignInfoData[0].custodianPhone
          ? String(this.batchSignInfoData[0].custodianPhone)
          : "";
      }

      if (this.formData.directorUserId) {
        this.formData.dissertationType = "无";
        this.formData.contractAt = [
          moment(new Date()).format("YYYY-MM-DD"),
          moment(new Date()).format("YYYY-MM-DD"),
        ];
        this.formData.directorUserId = this.batchSignInfoData[0].directorUserId; // 负责人id
        this.formData.directorUserName =
          this.batchSignInfoData[0].directorUserRealName; // 负责人
        this.directorUserPhone = this.batchSignInfoData[0].directorUserPhone;
        this.formData.deparment =
          this.batchSignInfoData[0].directorDepartmentlName;
      }

      this.customerInfo = {
        customerId: Number(this.batchSignInfoData[0].customerId),
        customerName: this.batchSignInfoData[0].customerName,
        customerSource: String(
          decodeURI(this.batchSignInfoData[0].customerSource as any),
        ),
        customerSourceType:
          this.batchSignInfoData[0].customerSourceType == "合作伙伴"
            ? "1"
            : "0",
        customerType: this.batchSignInfoData[0].customerType as any,
        marketCooperationId: Number(
          this.batchSignInfoData[0].marketCooperationId,
        ),
      };
      this.isReadonly = true;
    }
  }

  getYearColor(dateStr) {
    if (!dateStr) return "#666";
    const year = parseInt(dateStr.substring(0, 4));
    return year < this.currentYear ? "#f00" : "#666";
  }

  // 去掉空格
  removeSpaces1(str) {
    this.formData.idCard = str.replace(/\s+/g, "");
    return str.replace(/\s+/g, "");
  }

  removeSpaces2(str) {
    this.formData.psnAccount = str.replace(/\s+/g, "");
    return str.replace(/\s+/g, "");
  }

  removeSpaces3(str) {
    this.formData.custodianIdCard = str.replace(/\s+/g, "");
    return str.replace(/\s+/g, "");
  }

  removeSpaces4(str) {
    this.formData.custodianPhone = str.replace(/\s+/g, "");
    return str.replace(/\s+/g, "");
  }

  chiocesouCourseType(val) {
    // 当项目类型变化的时候清空以下数据
    this.formData.souCourseName = "";
    this.formData.souCoursePrice = "";
    this.formData.discountPrice = 0;
    this.formData.contractTemplateName = null;
    this.formData.souCourseSchoolBegin = "";
    this.onlyVal = false;
    if (this.$refs.dialogProjectTable)
      (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection();
  }

  changeAmount(val) {
    val = this.handleAmountOnInput(val, "2");
    this.formData.discountPrice = val;
    this.formData.contractTemplateName = null;
    // if (this.formData.contractTemplateName) {
    //     this.choiceContractTemplate(this.formData.contractTemplateName)
    // }
  }

  previewContractUrl() {
    window.open(this.contractOpenUrl, "blank");
  }

  handleAmountOnInput(num, limit) {
    const len1 = num.charAt(0);
    // 转化为数字形式--包含小数，负数
    // 先把非数字的都替换掉，除了数字和.
    num = num.replace(/[^\d.]/g, "");
    // 必须保证第一个为数字而不是.
    num = num.replace(/^\./g, "");
    // 保证只有出现一个.而没有多个.
    num = num.replace(/\.{2,}/g, ".");
    // 保证.只出现一次，而不能出现两次以上
    num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    // 如果第一位是负号，则允许添加
    if (len1 === "-") {
      num = "-" + num;
    }
    return num;
  }

  // 选择项目列表
  choiceProjectName() {
    this.dialogProjectPage = 1;
    if (this.formData.customerId === undefined) {
      this.$message.error("请选择客户");
      return;
    }

    if (!this.formData.customerName) {
      this.$message.error("请选择客户");
      return;
    }
    // if (!this.formData.souCourseType) {
    //     this.$message.error('请选择项目类型')
    //     return
    // }
    // if (!this.handletimeBegin) {
    //     this.$message.error('请选择开课时间')
    //     return
    // }
    this.formData.financeOrderCode = "";
    this.projectDialogShow = true;
    this.getProjectList();
    (this.$refs.projectInput as HTMLFormElement).blur();
  }

  selectable(row) {
    return row.flag;
  }

  async getProjectList() {
    this.projectDialogTableLoading = true;
    const obj = {
      marketCooperationId: this.customerInfo.marketCooperationId,
      name: this.dialogProjectInputValue,
      souCourseSchoolBegin: this.handletimeBegin, //项目开课时间
      page: this.dialogProjectPage,
      limit: this.dialogProjectLimit,
      financeOrderId: this.orderId,
      souCourseTypeId: this.formData.souCourseType,
      isFromContract: "1",
    };
    if (!this.orderId) {
      delete obj.financeOrderId;
    }

    for (const key in obj) {
      if (!obj[key]) {
        if (key == "souCourseSchoolBegin" || key == "souCourseTypeId") {
          delete obj[key];
        }
      }
    }

    const data: any = await getProjectList(obj);
    this.projectDialogTableData = data.projectList;

    // 初始化 将所有单选框置灰
    this.projectDialogTableData.forEach((item, currentIndex) => {
      this.$set(this.projectDialogTableData[currentIndex], "disabled", true);
      //将所有的默认值赋为0
      // this.$set(this.projectDialogTableData[currentIndex], 'radio', '0');
      this.$set(
        this.projectDialogTableData[currentIndex],
        "radio",
        item.souCourseName.indexOf(`\n`) !== -1
          ? item.souCourseName.split(`\n`)[0]
          : item.souCourseName,
      );
    });
    /*
     * 1、数据回显
     * 2、判断是否有选中项，有选中则将该条数据放开
     * */
    // 外边选中的
    // this.formModel.project
    this.projectDialogTableData.forEach((item1, index) => {
      if (item1.projectAllId == this.formData.projectAllId) {
        if (this.formData.souCourseName) {
          // debugger
          (
            this.$refs["dialogProjectTable"] as HTMLFormElement
          ).toggleRowSelection(item1);

          // 回显
          this.$set(
            this.projectDialogTableData[index],
            "radio",
            this.formData.souCourseName,
          );
        }
      }
    });

    this.dialogProjectTotal = data.allNum;
    this.projectDialogTableLoading = false;
  }

  projectLimitChange(limit: number) {
    this.dialogProjectLimit = limit;
    this.getProjectList();
  }

  projectPageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.dialogProjectPage = page;
      this.getProjectList();
    }, 1000);
  }

  dialogProjectTableCheckedChange(selection) {
    if (selection.length > 0) {
      this.intentionProjectSelected = selection;
      this.projectDialogCheckedTable = JSON.parse(JSON.stringify(selection[0]));

      const dom = this.$refs.dialogProjectTable as HTMLFormElement;
      if (selection.length > 1) {
        dom.clearSelection();
        dom.toggleRowSelection(selection.pop());
      }
    } else {
      for (const key in this.projectDialogCheckedTable) {
        this.projectDialogCheckedTable[key] = null;
      }
      // this.formModel.project = ''
      //  取消选中 将选中项目也置灰
      this.projectDialogTableData.forEach((item, currentIndex) => {
        this.$set(this.projectDialogTableData[currentIndex], "disabled", true);
      });
    }
  }

  // 选择项目弹框取消
  doCancel() {
    // 清空选中项
    (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection();
    this.projectDialogShow = false;
  }

  changeBeginClass(val) {
    // 清空项目名称的同时 清空弹窗里的勾选
    this.formData.souCourseName = "";
    this.formData.projectAllId = "";
  }

  // 选择意向项目确认
  async clickProjectDialogConfirmButton() {
    if (!this.projectDialogCheckedTable.projectAllId) {
      this.$message.error("请选择项目");
      return;
    }
    this.projectDialogShow = false;

    // if (this.customerInfo.marketCooperationId !== 0) {
    //     const data: any = await getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId({
    //         marketCooperationId: this.customerInfo.marketCooperationId,
    //         projectAllId: this.projectDialogCheckedTable.projectAllId
    //     })
    // }

    // 返显开课时间 和 项目类型

    this.typeList.forEach((item: any) => {
      if (item.label == this.projectDialogCheckedTable.souCourseType) {
        this.formData.souCourseType = item.value;
      }
    });
    if (
      this.projectDialogCheckedTable.souCourseSchoolBegin &&
      this.projectDialogCheckedTable.souCourseSchoolBegin !== "暂未设置开课时间"
    ) {
      this.formData.souCourseSchoolBegin = [
        this.projectDialogCheckedTable.souCourseSchoolBegin,
        this.projectDialogCheckedTable.souCourseSchoolBegin,
      ] as any;
    }
    //订单多个价格下拉

    if (this.projectDialogCheckedTable.souCoursePrice.includes("/")) {
      this.souCoursePriceList =
        this.projectDialogCheckedTable.souCoursePrice.split("/");
    } else {
      this.souCoursePriceList = [this.projectDialogCheckedTable.souCoursePrice];
    }
    this.formData.souCoursePrice = this.souCoursePriceList[0]; // 默认取第一个值
    this.projectDialogTableData.forEach((item) => {
      if (item.projectAllId == this.projectDialogCheckedTable.projectAllId) {
        this.$set(this.formData, "souCourseName", item.radio);
        this.formData.projectAllId = item.projectAllId;
        this.souCourseSchoolBegin =
          item.souCourseSchoolBegin &&
          item.souCourseSchoolBegin !== "暂未设置开课时间"
            ? item.souCourseSchoolBegin
            : "";
        this.templateRemark = item.remark;
        /*
         * 关于论文服务类型 加论文（可以）：论文服务类型任选，加论文（不可以）：论文类型只能选无*/
        if (item.isHaveDissertation == "0") {
          this.formData.dissertationType = "无";
          this.isAbled = true;
        } else {
          this.isAbled = false;
        }
      }
    });

    if (!this.formData.projectAllId) {
      this.$message.error("请选择项目");
      return;
    }
    // 合同中获取订单信息
    this.getFinancOrder();
    this.$forceUpdate();
  }

  async getFinancOrder() {
    const { financeOrder }: any = await getFinancOrder({
      customerId: Number(this.formData.customerId),
      customerType: this.customerInfo.customerType,
      projectAllId: this.formData.projectAllId,
    });
    if (financeOrder) {
      this.isOrder = true;
      this.formData.financeOrderCode = financeOrder.code;
      this.formData.company = financeOrder.companyName;
      this.formData.dissertationType = financeOrder.dissertationType;
      this.formData.souCoursePrice = financeOrder.souCoursePrice;
      this.formData.discountPrice = financeOrder.discountPrice;
      //  佣金类型 + 返点比例或结算价
      this.formData.commissionType = financeOrder.commissionType;
      this.formData.priceOrRatio = financeOrder.priceOrRatio;
      this.projectDisabled = true;
      /*有订单 所属公司默认带出来的情况*/
      this.companyList.forEach((item) => {
        if (this.formData.company == item.name) {
          this.accountObj = item;
        }
      });
    } else if (financeOrder === null) {
      this.isOrder = false;
      this.projectDisabled = false;
      // this.formData.souCoursePrice = ''
      // this.formData.dissertationType = ''
      this.formData.company = "";
      this.onlyVal = false;
      if (this.souCoursePriceList.length == 1) {
        this.formData.souCoursePrice =
          this.projectDialogCheckedTable.souCoursePrice;
        this.onlyVal = true;
      }

      if (this.customerInfo.marketCooperationId !== 0) {
        const data: any =
          await getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId(
            {
              marketCooperationId: this.customerInfo.marketCooperationId,
              projectAllId: this.projectDialogCheckedTable.projectAllId,
            },
          );
        // 返点比例 默认取第一个值
        this.priceOrRatioList = data.priceOrRatio;
        this.formData.commissionType = data.commissionType;
        if (this.formData.commissionType === "1") {
          this.formData.priceOrRatio = this.priceOrRatioList.includes("/")
            ? this.priceOrRatioList.split("/")[0]
            : this.priceOrRatioList;
        }
        if (this.formData.commissionType === "2") {
          this.formData.priceOrRatio = data.priceOrRatio; // 返点比例
        }
      } else {
        this.formData.commissionType = "0"; // 无佣金类型
        this.formData.priceOrRatio = "";
      }
    }
  }

  changeSouCoursePrice(val) {
    if (this.formData.commissionType === "0") {
      this.formData.priceOrRatio = "";
    }
    if (this.formData.commissionType === "1") {
      const list = this.priceOrRatioList.split("/");
      if (list.length > 1) {
        this.formData.priceOrRatio =
          list[this.souCoursePriceList.indexOf(this.formData.souCoursePrice)];
      } else {
        this.formData.priceOrRatio = this.priceOrRatioList.includes("/")
          ? this.priceOrRatioList.split("/")[0]
          : this.priceOrRatioList;
      }
    }
    if (this.formData.commissionType === "2") {
      this.formData.priceOrRatio = this.priceOrRatioList; // 返点比例
    }
  }

  changeISAdult(val) {
    if (val === "是") {
      this.formData.psnAccount = "";
      this.formData.custodianName = "";
      this.formData.custodianIdCard = "";
      this.formData.custodianPhone = "";
    }
    this.formData.contractTemplateName = ""; // 清空合同模板
  }

  // 当有信息变动清空合同模板
  changeInfo() {
    this.formData.contractTemplateName = ""; // 清空合同模板
    this.$forceUpdate();
  }

  async getFinanceContractInfoById() {
    this.formLoading = true;
    this.isReplace = true;
    await getFinanceContractInfoById(
      delNullProperty({
        id: this.contractId,
      }),
    )
      .then((data: any) => {
        const { financeContract } = data;
        this.formData = financeContract;
        this.formData.customerName = financeContract.mainPartName;
        this.marketCooperationName = financeContract.mainPartName;
        this.customerType = financeContract.customerType;

        this.$set(
          this.formData,
          "this.formData.marketCooperationId",
          financeContract.marketCooperationId,
        );
        this.formData.customerId = financeContract.customerId;
        // this.formData.customerOrParternerName = financeContract.mainPartName
        this.formData.contractAt = financeContract.contractAt.split("&");
        this.formData.source = financeContract.customerSource;

        this.contractCode = financeContract.code;
        this.contractOpenUrl = financeContract.url;
        this.formData.directorUserId = financeContract.directorUserId;
        this.formData.directorUserName = financeContract.directorUserRealName;
        this.directorUserPhone = financeContract.directorUserPhone;
        this.formData.deparment = financeContract.directorDepartmentName;
        this.formData.souCourseSchoolBegin = [
          financeContract.souCourseSchoolBegin.replace(/-/g, "/"),
          financeContract.souCourseSchoolBegin.replace(/-/g, "/"),
        ] as any;

        this.formData.souCourseType = financeContract.souCourseTypeId;
        this.customerInfo.customerType = financeContract.customerType;
        // this.customerInfo.priceOrRatio = financeContract.priceOrRatio
        // this.formData.projectAllId = financeContract.projectAllId
        this.customerInfo.marketCooperationId =
          financeContract.marketCooperationId;
        this.formData.discountPrice = financeContract.discountPrice;
        this.projectDialogCheckedTable.souTeacherName =
          financeContract.souTeacherName;

        if (this.formData.financeOrderCode) {
          this.projectDisabled = true;
          this.isReadonlyproject = true;
        }
        this.companyList.forEach((item) => {
          if (this.formData.company == item.name) {
            this.accountObj = item;
          }
        });
        this.formData.contractTemplateName = " ";
        this.formLoading = false;
      })
      .catch((err) => {
        this.formLoading = false;
      });
  }

  // directorUserIdChange(newValue) {
  //     const selectedItem = this.userList.find(item => item.id === newValue);
  //     this.formData.deparment = selectedItem.departmentName
  // }

  // 去空格
  trimAll(ele) {
    if (typeof ele === "string") {
      return ele.split(" ").join("");
    } else {
      console.error(
        `${typeof ele} is not the expected type, but the string type is expected`,
      );
    }
  }

  async getItemStudentData(item, index) {
    const contractHtml = this.contractDetail;
    let newStr = contractHtml.replace(
      "公司名称",
      item.company ? item.company : this.formData.company,
    );
    newStr = newStr.replace(
      "请输入公司统一社会信用代码",
      item.accountObj ? item.accountObj.code : this.code,
    );
    newStr = newStr.replace(
      "请输入公司地址",
      item.accountObj ? item.accountObj.address : this.address,
    );
    newStr = newStr.replace("请输入姓名", item.customerName);
    newStr = newStr.replace("请输入学生身份证", item.idCard ? item.idCard : "");
    newStr = newStr.replace(
      "请输入学生手机号",
      item.psnAccount ? item.psnAccount : "",
    );
    newStr = newStr.replace(
      "请输入法定监护人姓名",
      item.isAdult == "否" ? item.custodianName : "",
    );
    newStr = newStr.replace(
      "请输入监护人身份证号码",
      item.isAdult == "否"
        ? item.custodianIdCard
          ? item.custodianIdCard
          : ""
        : "",
    );
    newStr = newStr.replace(
      "请输入法定监护人手机号码",
      item.isAdult == "否" ? item.custodianPhone : "",
    );
    // let str9
    if (
      Number(
        item.discountPrice ? item.discountPrice : this.formData.discountPrice,
      ) > 0
    ) {
      const newMoney = math.number(
        math.subtract(
          math.bignumber(Number(this.formData.souCoursePrice)),
          math.bignumber(Number(this.formData.discountPrice)),
        ),
      );

      // const newMoney = math.number(math.subtract(math.bignumber(Number(item.souCoursePrice ? item.souCoursePrice : this.formData.souCoursePrice)), math.bignumber(Number(item.discountPrice ? item.discountPrice : this.formData.discountPrice))));
      newStr = newStr.replaceAll(
        "{{优惠金额}}",
        "，项目优惠金额" +
          (item.discountPrice
            ? item.discountPrice
            : this.formData.discountPrice) +
          "元人民币/人，本协议约定项目费用共计" +
          newMoney +
          "元人民币/人",
      );
    } else {
      newStr = newStr.replaceAll("{{优惠金额}}", "");
    }
    // 备注替换字段

    if (this.templateRemark) {
      newStr = newStr.replaceAll(
        "{{备注}}",
        '<p style="white-space: pre-wrap;">' + this.templateRemark + "</p>",
      );
    } else {
      newStr = newStr.replaceAll("{{备注}}", "");
    }
    // 项目金额 formData.souCoursePrice
    newStr = newStr.replaceAll(
      "{{项目金额}}",
      item.souCoursePrice ? item.souCoursePrice : this.formData.souCoursePrice,
    );

    // 收款账户替换字段

    const accountObj =
      "<p>账户名称：" +
      (item.accountObj ? item.accountObj.name : this.accountObj.name) +
      "</p>" +
      "<p>收款人地址：" +
      (item.accountObj ? item.accountObj.address : this.accountObj.address) +
      "</p>" +
      "<p>账户号：" +
      (item.accountObj
        ? item.accountObj.bankAccount
        : this.accountObj.bankAccount) +
      "</p>" +
      "<p>开户银行：" +
      (item.accountObj ? item.accountObj.bank : this.accountObj.bank) +
      "</p>" +
      "<p>银行行号：" +
      (item.accountObj ? item.accountObj.bankCode : this.accountObj.bankCode) +
      "</p>";
    newStr = newStr.replaceAll("{{收款账户}}", accountObj);

    // this.contractTemplateDetail = str111

    const str11 = this.formData.contractAt[0];
    const arr22 = str11.split("-");
    // document.getElementById('companySign').innerHTML = this.formData.company
    if ((item.isAdult ? item.isAdult : this.formData.isAdult) === "是") {
      // 成年直接签字（图片类型）
      // document.getElementById('guardianNameSign').innerHTML = '';
      newStr = newStr.replace(
        'img(style="width:100%;display: none;" src="" id="guardianNameSignImg")',
        "",
      );
    } else {
      // document.getElementById('nameSign').innerHTML = this.formData.customerName
      newStr = newStr.replace(
        'b(id="nameSign" style="display: none;width:30%;")',
        'b(id="nameSign" style="display: none;width:30%;")' + item.customerName,
      );
    }
    //
    if (
      !this.souCourseSchoolBegin ||
      this.souCourseSchoolBegin == "暂未设置开课时间"
    ) {
      this.souCourseSchoolBegin =
        this.formData.souCourseSchoolBegin &&
        this.formData.souCourseSchoolBegin.length > 0
          ? this.formData.souCourseSchoolBegin[0]
          : "";
    }
    // const arr = this.souCourseSchoolBegin.split('/')
    // document.getElementById('projectName').innerHTML = this.formData.souCourseName + '【开课时间：' + arr[0] + '年' + arr[1] +
    //     '月' + arr[2] + '日' + '】';
    // (document.getElementById('imgContract') as HTMLFormElement).src = this.contractUrl
    // document.getElementById('jiaYear').innerHTML = arr22[0]
    // document.getElementById('jiaMonth').innerHTML = arr22[1]
    // document.getElementById('jiaDay').innerHTML = arr22[2]
    // const html = document.getElementById('contractTem').outerHTML

    newStr = newStr.replace(
      'id="companySign">',
      'id="companySign">' +
        (item.company ? item.company : this.formData.company),
    );

    if (
      this.souCourseSchoolBegin &&
      this.souCourseSchoolBegin !== "暂未设置开课时间"
    ) {
      const list = this.souCourseSchoolBegin.split("/");
      const strStart = list[0] + "年" + list[1] + "月" + list[2] + "日";
      // 判断项目类型 如果是国外小组科研、海外导师线下项目，在最前面增加导师名称，其他照旧
      if (
        item.souCourseType === "国外小组科研" ||
        item.souCourseType === "海外导师线下项目"
      ) {
        newStr = newStr.replace(
          'id="projectName">',
          'id="projectName">' +
            "【导师：" +
            item.souTeacherName +
            "】" +
            (item.souCourseName
              ? item.souCourseName
              : this.formData.souCourseName) +
            "【开课时间：" +
            strStart +
            "】",
        );
      } else {
        newStr = newStr.replace(
          'id="projectName">',
          'id="projectName">' +
            (item.souCourseName
              ? item.souCourseName
              : this.formData.souCourseName) +
            "【开课时间：" +
            strStart +
            "】",
        );
      }
    } else {
      if (
        item.souCourseType === "国外小组科研" ||
        item.souCourseType === "海外导师线下项目"
      ) {
        newStr = newStr.replace(
          'id="projectName">',
          'id="projectName">' +
            "【导师：" +
            item.souTeacherName +
            "】" +
            (item.souCourseName
              ? item.souCourseName
              : this.formData.souCourseName),
        );
      } else {
        newStr = newStr.replace(
          'id="projectName">',
          'id="projectName">' +
            (item.souCourseName
              ? item.souCourseName
              : this.formData.souCourseName),
        );
      }
    }
    newStr = newStr.replace('id="jiaYear">', 'id="jiaYear">' + arr22[0]);
    newStr = newStr.replace('id="jiaMonth">', 'id="jiaMonth">' + arr22[1]);
    newStr = newStr.replace('id="jiaDay">', 'id="jiaDay">' + arr22[2]);
    newStr = newStr.replace(
      'src="" id="imgContract"',
      'src="' +
        (item.accountObj ? item.accountObj.contractUrl : this.contractUrl) +
        '"' +
        'id="imgContract"',
    );

    /*若负责人是带过来的无更改用带过来的数据，若有更改则统一都用更改完成的，若批量的学生没有负责人则用统一选定的*/
    /*20250902 需求 生成的合同删除负责人和手机号字段*/
    // newStr = newStr.replace('id="directorName">', 'id="directorName">' + (item.directorUserRealName ? item.directorUserRealName : this.formData.directorUserName) + ' ' + (item.directorUserPhone ? item.directorUserPhone : this.directorUserPhone))
    // 查询是否存在'负责人姓名及手机号：'
    if (newStr.indexOf("<td>负责人姓名及手机号：") !== -1) {
      newStr = newStr.replace("<td>负责人姓名及手机号：", "<td> ");
    }
    item.html = newStr;
    await generatePdf({
      htmlStr: item.html,
      marginTop: 80,
      marginBottom: 80,
    }).then((res) => {
      const data: any = res;
      item.url = data.url;
      const flagIsAdult = this.types == "0" && item.isAdult == "是";
      const obj: any = {
        customerId: item.customerId, // 客户信息
        customerType: item.customerType,
        directorUserId: item.directorUserId
          ? item.directorUserId
          : this.formData.directorUserId,
        company: item.company ? item.company : this.formData.company,
        isAdult: item.isAdult == "否" ? "0" : "1",
        custodianName: !flagIsAdult ? item.custodianName.trim() : "", // 监护人姓名 // 当types = '0'时且isAdult = '0'时必需
        custodianPhone: !flagIsAdult
          ? item.custodianPhone
            ? String(item.custodianPhone)
            : ""
          : "",
        custodianIdCard: !flagIsAdult
          ? item.custodianIdCard
            ? String(item.custodianIdCard)
            : ""
          : "",
        contractAt: this.changeTime(this.formData.contractAt as Date[]),
        types: this.types, //合同类型
        mainPart: "0",
        signTypes: "0",
        sealTypes: "0", // 加盖印章 只能为0 合同章
        psnAccount: item.psnAccount ? String(item.psnAccount) : "",
        idCard: item.idCard ? String(item.idCard) : "",
        fileTypes: "0", // 当types = '0'时只能传'0'
        url: item.url, // pdfUrl
        sourceType: item.customerSourceType, // 当types = '0'时必需 客户来源
        dissertationType: item.dissertationType
          ? item.dissertationType
          : this.formData.dissertationType, // 当types = '0'时必需
        priceOrRatio:
          (item.commissionType
            ? item.commissionType
            : this.formData.commissionType) !== "0"
            ? item.priceOrRatio
              ? String(item.priceOrRatio)
              : ""
            : "", // 当types = '0'时必需 ，结算价或者返点比例，存在时不传
        commissionType: item.commissionType
          ? item.commissionType
          : this.formData.commissionType, // 当types = '0'时必需
        souCoursePrice: item.souCoursePrice
          ? item.souCoursePrice
          : this.formData.souCoursePrice, // 当types = '0'时必需
        projectAllId: this.formData.projectAllId, // 项目ID
        source: item.customerSource
          ? item.customerSource
          : this.formData.source,
        discountPrice: (
          item.discountPrice ? item.discountPrice : this.formData.discountPrice
        )
          ? item.discountPrice
            ? item.discountPrice
            : this.formData.discountPrice
          : "0", // 优惠金额
        souCourseName: this.formData.souCourseName,
      };
      this.disabledButton = true;
      setTimeout(async () => {
        await setFinanceContract(delNullProperty(obj))
          .then((res) => {
            this.requestDataList.push(index);
          })
          .catch(() => {
            this.requestDataList.push(-1);
          });
      }, 100 * index);
    });
  }

  /*批量签署合同*/
  async batchSignContract() {
    //  遍历校验
    let flag = true;

    // 判断每条数据是否都有isAdult
    if (this.batchSignInfoData.some((item) => !item.isAdult)) {
      this.$message.error("学生必填信息不全！");
      flag = false;
      return;
    }
    this.batchSignInfoData.forEach((item) => {
      if (item.isAdult == "是") {
        //     学生信息是否齐全
        if (!item.customerName || !item.customerId || !item.psnAccount) {
          this.$message.error("批量处理中有学生必填信息不全");
          flag = false;
          return;
        }
      } else if (item.isAdult == "否") {
        // 家长信息是否齐全
        if (!item.customerName || !item.custodianName || !item.custodianPhone) {
          this.$message.error("批量处理中有家长必填信息不全");
          flag = false;
          return;
        }
      }
    });
    if (!flag) {
      return;
    }
    this.formLoading = true;
    this.requestDataList = [];
    this.batchSignInfoData.map(
      async (item, index) =>
        await getFinancOrder({
          customerId: Number(item.customerId),
          customerType: item.customerType,
          projectAllId: this.formData.projectAllId,
        }).then(async (res) => {
          const data: any = res;
          this.$set(item, "financeOrder", data.financeOrder);
          if (item.financeOrder && item.financeOrder.code) {
            item.financeOrderCode = item.financeOrder.code;
            item.company = item.financeOrder.companyName;
            item.dissertationType = item.financeOrder.dissertationType;
            item.souCoursePrice = item.financeOrder.souCoursePrice;
            item.discountPrice = item.financeOrder.discountPrice;
            // item.code = item.financeOrder.code
            const obj = this.companyList.find(
              (item1) => item1.name === item.company,
            );
            if (obj) {
              item.accountObj = obj;
            }
            //  佣金类型 + 返点比例或结算价
            item.commissionType = item.financeOrder.commissionType;
            item.priceOrRatio = item.financeOrder.priceOrRatio;
            await this.getItemStudentData(item, index);
          } else {
            if (item.marketCooperationId * 1 === 0) {
              item.commissionType = "0"; // 无佣金类型
              item.priceOrRatio = "";
              this.getItemStudentData(item, index);
            } else {
              await getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId(
                {
                  marketCooperationId: item.marketCooperationId,
                  projectAllId: Number(this.formData.projectAllId),
                },
              ).then(async (res) => {
                const data: any = res;
                const priceOrRatioList = data.priceOrRatio;
                item.commissionType = data.commissionType;
                if (item.commissionType === "0") {
                  item.priceOrRatio = "";
                }
                if (item.commissionType === "1") {
                  const list = priceOrRatioList.split("/");
                  if (list.length > 1) {
                    item.priceOrRatio =
                      list[
                        this.souCoursePriceList.indexOf(
                          this.formData.souCoursePrice,
                        )
                      ];
                  } else {
                    item.priceOrRatio = priceOrRatioList.includes("/")
                      ? priceOrRatioList.split("/")[0]
                      : priceOrRatioList;
                  }
                }
                if (item.commissionType === "2") {
                  item.priceOrRatio = priceOrRatioList; // 返点比例
                }
                await this.getItemStudentData(item, index);
              });
            }
          }
        }),
    );
    return;
    /* // [弃用]
             const promises = this.batchSignInfoData.map(async (item,index) =>
                 await getFinancOrder({
                     customerId: Number(item.customerId),
                     customerType: item.customerType,
                     projectAllId: this.formData.projectAllId,
                 }).then((res) => {
                     const data: any = res
                     this.$set(item, 'financeOrder', data.financeOrder)
                 })
             )
             // 【弃用】使用Promise.all等待所有接口调用完成
             Promise.all(promises).then(results => {
                 const promises1 = this.batchSignInfoData.map(item => {
                         if (item.financeOrder) {
                             item.financeOrderCode = item.financeOrder.code
                             item.company = item.financeOrder.companyName
                             item.dissertationType = item.financeOrder.dissertationType
                             item.souCoursePrice = item.financeOrder.souCoursePrice
                             item.discountPrice = item.financeOrder.discountPrice
                             // item.code = item.financeOrder.code
                             const obj = this.companyList.find(item1 => item1.name === item.company)
                             if (obj) {
                                 item.accountObj = obj
                             }
                             //  佣金类型 + 返点比例或结算价
                             item.commissionType = item.financeOrder.commissionType
                             item.priceOrRatio = item.financeOrder.priceOrRatio
                         } else {
                             if (item.marketCooperationId * 1 === 0) {
                                 item.commissionType = '0' // 无佣金类型
                                 item.priceOrRatio = ''
                                 return
                             }
                             getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId({
                                 marketCooperationId: item.marketCooperationId,
                                 projectAllId: Number(this.formData.projectAllId),
                             }).then((res) => {
                                 const data: any = res
                                 const priceOrRatioList = data.priceOrRatio
                                 item.commissionType = data.commissionType
                                 if (item.commissionType === '0') {
                                     item.priceOrRatio = ''
                                 }
                                 if (item.commissionType === '1') {
                                     const list = priceOrRatioList.split('/')
                                     if (list.length > 1) {
                                         item.priceOrRatio = list[this.souCoursePriceList.indexOf(this.formData.souCoursePrice)]
                                     } else {
                                         item.priceOrRatio = priceOrRatioList.includes('/') ? priceOrRatioList.split('/')[0] : priceOrRatioList
                                     }
                                 }
                                 if (item.commissionType === '2') {
                                     item.priceOrRatio = priceOrRatioList  // 返点比例
                                 }
                             })
                         }
                         // return ({...item})
                     }
                 );
                 Promise.all(promises1).then(results => {
                     this.batchSignInfoData.map((item, index) => {
                         const contractHtml = this.contractDetail
                         let newStr = contractHtml.replace('公司名称', item.company ? item.company : this.formData.company);
                         newStr = newStr.replace('请输入公司统一社会信用代码', item.accountObj ? item.accountObj.code : this.code);
                         newStr = newStr.replace('请输入公司地址', item.accountObj ? item.accountObj.address : this.address);
                         newStr = newStr.replace('请输入姓名', item.customerName);
                         newStr = newStr.replace('请输入学生身份证', item.idCard ? item.idCard : '');
                         newStr = newStr.replace('请输入学生手机号', item.psnAccount ? item.psnAccount : '');
                         newStr = newStr.replace('请输入法定监护人姓名', item.isAdult == '否' ? item.custodianName : '');
                         newStr = newStr.replace('请输入监护人身份证号码', item.isAdult == '否' ? item.custodianIdCard ? item.custodianIdCard : '' : '');
                         newStr = newStr.replace('请输入法定监护人手机号码', item.isAdult == '否' ? item.custodianPhone : '');
                         // let str9
                         if (Number(item.discountPrice ? item.discountPrice : this.formData.discountPrice) > 0) {
                             const newMoney = math.number(math.subtract(math.bignumber(Number(item.souCoursePrice ? item.souCoursePrice : this.formData.souCoursePrice)), math.bignumber(Number(item.discountPrice ? item.discountPrice : this.formData.discountPrice))));
                             newStr = newStr.replaceAll('{{优惠金额}}', '，项目优惠金额' + (item.discountPrice ? item.discountPrice : this.formData.discountPrice) + '元人民币/人，本协议约定项目费用共计' + newMoney + '元人民币/人');
                         } else {
                             newStr = newStr.replaceAll('{{优惠金额}}', '');
                         }
                         // 备注替换字段

                         if (this.templateRemark) {
                             newStr = newStr.replaceAll('{{备注}}', '<p style="white-space: pre-wrap;">' + this.templateRemark + '</p>');
                         } else {
                             newStr = newStr.replaceAll('{{备注}}', '');
                         }

                         // 项目金额替换字段
                         newStr = newStr.replaceAll('{{项目金额}}', item.souCoursePrice ? item.souCoursePrice :this.formData.souCoursePrice)

                         // 收款账户替换字段

                         const accountObj = '<p>账户名称：' + (item.accountObj ? item.accountObj.name : this.accountObj.name) + '</p>' +
                             '<p>收款人地址：' + (item.accountObj ? item.accountObj.address : this.accountObj.address) + '</p>' +
                             '<p>账户号：' + (item.accountObj ? item.accountObj.bankAccount : this.accountObj.bankAccount) + '</p>' +
                             '<p>开户银行：' + (item.accountObj ? item.accountObj.bank : this.accountObj.bank) + '</p>' +
                             '<p>银行行号：' + (item.accountObj ? item.accountObj.bankCode : this.accountObj.bankCode) + '</p>'
                         newStr = newStr.replaceAll('{{收款账户}}', accountObj);

                         // this.contractTemplateDetail = str111

                         // const str11 = this.formData.contractAt[0]
                         // const arr22 = str11.split('-')
                         // document.getElementById('companySign').innerHTML = this.formData.company
                         if ((item.isAdult ? item.isAdult : this.formData.isAdult) === '是') {  // 成年直接签字（图片类型）
                             // document.getElementById('guardianNameSign').innerHTML = '';
                             newStr = newStr.replace('img(style="width:100%;display: none;" src="" id="guardianNameSignImg")', '');
                         } else {
                             // document.getElementById('nameSign').innerHTML = this.formData.customerName
                             newStr = newStr.replace('b(id="nameSign" style="display: none;width:30%;")', 'b(id="nameSign" style="display: none;width:30%;")' + item.customerName)
                         }
                         //
                         if (!this.souCourseSchoolBegin || this.souCourseSchoolBegin =='暂未设置开课时间') {
                             this.souCourseSchoolBegin = (this.formData.souCourseSchoolBegin && this.formData.souCourseSchoolBegin.length > 0 )? this.formData.souCourseSchoolBegin[0] : ''
                         }
                         // const arr = this.souCourseSchoolBegin.split('/')
                         // document.getElementById('projectName').innerHTML = this.formData.souCourseName + '【开课时间：' + arr[0] + '年' + arr[1] +
                         //     '月' + arr[2] + '日' + '】';
                         // (document.getElementById('imgContract') as HTMLFormElement).src = this.contractUrl
                         // document.getElementById('jiaYear').innerHTML = arr22[0]
                         // document.getElementById('jiaMonth').innerHTML = arr22[1]
                         // document.getElementById('jiaDay').innerHTML = arr22[2]
                         // const html = document.getElementById('contractTem').outerHTML

                         newStr = newStr.replace('id="companySign">', 'id="companySign">' + (item.company ? item.company : this.formData.company))

                         if (this.souCourseSchoolBegin && this.souCourseSchoolBegin !== '暂未设置开课时间') {
                             const list = this.souCourseSchoolBegin.split('/')
                             const strStart = list[0] + '年' + list[1] + '月' + list[2] + '日'
                             // 判断项目类型 如果是国外小组科研、海外导师线下项目，在项目名称前面增加导师名称，其他照旧
                             if (item.souCourseType === '国外小组科研' || item.souCourseType === '海外导师线下项目') {
                                 newStr = newStr.replace('id="projectName">', 'id="projectName">' + '【导师：' + item.souTeacherName + '】' + (item.souCourseName ? item.souCourseName : this.formData.souCourseName) + '【开课时间：' + strStart + '】')
                             } else {
                                 newStr = newStr.replace('id="projectName">', 'id="projectName">' + (item.souCourseName ? item.souCourseName : this.formData.souCourseName) + '【开课时间：' + strStart + '】')
                             }

                         } else {
                             if (item.souCourseType === '国外小组科研' || item.souCourseType === '海外导师线下项目') {
                                 newStr = newStr.replace('id="projectName">', 'id="projectName">' + '【导师：' + item.souTeacherName + '】' + (item.souCourseName ? item.souCourseName : this.formData.souCourseName))
                             } else {
                                 newStr = newStr.replace('id="projectName">', 'id="projectName">' + (item.souCourseName ? item.souCourseName : this.formData.souCourseName))
                             }
                         }
                         newStr = newStr.replace('src="" id="imgContract"', 'src="' + (item.accountObj ? item.accountObj.contractUrl : this.contractUrl) + '"' + 'id="imgContract"')
                         /!*20250902 需求 生成的合同删除负责人和手机号字段*!/
                         // newStr = newStr.replace('id="directorName")', 'id="directorName")' + this.formData.directorUserName + ' ' + this.directorUserPhone)
                         // 查询是否存在'负责人姓名及手机号：'
                         if (newStr.indexOf('<td>负责人姓名及手机号：') !== -1) {
                             newStr = newStr.replace('<td>负责人姓名及手机号：', '<td> ')
                         }
                         const str11 = this.formData.contractAt[0]
                         const arr22 = str11.split('-')
                         newStr = newStr.replace('id="jiaYear">', 'id="jiaYear">' + arr22[0])
                         newStr = newStr.replace('id="jiaMonth">', 'id="jiaMonth">' + arr22[1])
                         newStr = newStr.replace('id="jiaDay">', 'id="jiaDay">' + arr22[2])
                         item.html = newStr
                     })
                     const promises2 = this.batchSignInfoData.map(item =>
                         generatePdf({
                             htmlStr: item.html,
                             marginTop: 80,
                             marginBottom: 80,
                         }).then((res) => {
                             const data: any = res
                             item.url = data.url
                         })
                     );
                     Promise.all(promises2).then(results => {
                         this.requestDataList = []
                         const promises3 = this.batchSignInfoData.map((item,index) => {
                                 const flagIsAdult = this.types == '0' && item.isAdult == '是'
                                 const obj: any = {
                                     customerId: item.customerId, // 客户信息
                                     customerType: item.customerType,
                                     directorUserId: this.formData.directorUserId,
                                     company: item.company ? item.company : this.formData.company,
                                     isAdult: item.isAdult == '否' ? '0' : '1',
                                     custodianName: !flagIsAdult ? item.custodianName.trim() : '', // 监护人姓名 // 当types = '0'时且isAdult = '0'时必需
                                     custodianPhone: !flagIsAdult ? (item.custodianPhone ? String(item.custodianPhone) : '') : '',
                                     custodianIdCard: !flagIsAdult ? (item.custodianIdCard ? String(item.custodianIdCard) : '') : '',
                                     contractAt: this.changeTime(this.formData.contractAt as Date[]),
                                     types: this.types,  //合同类型
                                     mainPart: '0',
                                     signTypes: '0',
                                     sealTypes: '0', // 加盖印章 只能为0 合同章
                                     psnAccount: item.psnAccount ? String(item.psnAccount) : '',
                                     idCard: item.idCard ? String(item.idCard) : '',
                                     fileTypes: '0', // 当types = '0'时只能传'0'
                                     url: item.url, // pdfUrl
                                     sourceType: item.customerSourceType, // 当types = '0'时必需 客户来源
                                     dissertationType: item.dissertationType ? item.dissertationType : this.formData.dissertationType, // 当types = '0'时必需
                                     priceOrRatio: (item.commissionType ? item.commissionType : this.formData.commissionType) !== '0' ? (item.priceOrRatio ? String(item.priceOrRatio) : '') : '', // 当types = '0'时必需 ，结算价或者返点比例，存在时不传
                                     commissionType: item.commissionType ? item.commissionType : this.formData.commissionType, // 当types = '0'时必需
                                     souCoursePrice: item.souCoursePrice ? item.souCoursePrice :this.formData.souCoursePrice, // 当types = '0'时必需
                                     projectAllId: this.formData.projectAllId, // 项目ID
                                     source: item.customerSource ? item.customerSource : this.formData.source,
                                     discountPrice: (item.discountPrice ? item.discountPrice : this.formData.discountPrice) ? (item.discountPrice ? item.discountPrice : this.formData.discountPrice) : '0', // 优惠金额
                                     souCourseName: this.formData.souCourseName,
                                 };
                                 this.disabledButton = true;
                                 setTimeout(()=>{
                                     setFinanceContract(delNullProperty(obj)).then((res)=>{
                                         this.requestDataList.push(index)
                                     }).catch(()=>{
                                         this.requestDataList.push(-1)
                                     })
                                 },100*index)
                             }
                         ); // fetchData是调用接口的函数
                         // Promise.all(promises3).then(res => {
                         //     this.disabledButton = false;
                         //     this.formLoading = false
                         //     this.$message.success('合同签署成功')
                         //     setTimeout(() => {
                         //         this.closePage()
                         //     }, 1500)
                         // })
                     })
                 })
             }).catch(error => {
                 // 处理错误
                 this.formLoading = false
             });*/
  }

  /*保存并提交*/
  doSaveAndSubmit() {
    // 校验
    if (!this.formData.customerId) {
      this.$message.error("客户名称不可为空");
      return;
    }
    if (!this.formData.contractAt) {
      this.$message.error("合同签订期限不可为空");
      return;
    }
    if (!this.contractTemplateDetail) {
      this.$message.error("请选择合同模板");
      return;
    }
    if (!this.formData.directorUserId) {
      this.$message.error("请选择负责人");
      return;
    }

    if (this.formData.psnAccount === " ") {
      this.formData.psnAccount = "";
    }

    let flag = true;
    (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
      if (!valid) {
        flag = false;
        return;
      }
    });
    if (!flag) {
      return;
    }
    if (!this.batchSign) {
      this.clickSubmintButton();
    } else {
      this.batchSignContract();
    }
  }

  /*保存*/
  clickSubmintButton() {
    this.formLoading = true;
    generatePdf({
      htmlStr: this.contractTemplateDetail,
      marginTop: 80,
      marginBottom: 80,
    }).then((res: any) => {
      this.formData.contractUrl = res.url;
      const flagIsAdult = this.types == "0" && this.formData.isAdult == "1";
      // const flagAboutOrder = this.types == '0' && this.isOrder // 订单是否存在（是）

      const obj: any = {
        customerId: this.formData.customerId, // 客户信息
        customerType: this.customerInfo.customerType,
        directorUserId: this.formData.directorUserId,
        company: this.formData.company,
        isAdult: this.formData.isAdult,
        custodianName: !flagIsAdult ? this.formData.custodianName.trim() : "", // 监护人姓名 // 当types = '0'时且isAdult = '0'时必需
        custodianPhone: !flagIsAdult ? this.formData.custodianPhone : "",
        custodianIdCard: !flagIsAdult ? this.formData.custodianIdCard : "",
        contractAt: this.changeTime(this.formData.contractAt as Date[]),
        types: this.types, //合同类型
        mainPart: "0",
        signTypes: "0",
        sealTypes: "0", // 加盖印章 只能为0 合同章
        psnAccount: this.formData.psnAccount,
        idCard: this.formData.idCard,
        fileTypes: "0", // 当types = '0'时只能传'0'
        url: this.formData.contractUrl, // pdfUrl
        sourceType: this.formData.sourceType, // 当types = '0'时必需 客户来源
        // isDoubleSouCourseName: flagAboutOrder ? this.formData.isDoubleSouCourseName : '', // 当types = '0'时且订单不存在时必需
        dissertationType: this.formData.dissertationType, // 当types = '0'时必需
        priceOrRatio:
          this.formData.commissionType !== "0"
            ? this.formData.priceOrRatio
            : "", // 当types = '0'时必需 ，结算价或者返点比例，存在时不传
        commissionType: this.formData.commissionType, // 当types = '0'时必需
        souCoursePrice: this.formData.souCoursePrice, // 当types = '0'时必需
        projectAllId: this.formData.projectAllId, // 项目ID
        source: this.formData.source,
        discountPrice: this.formData.discountPrice
          ? this.formData.discountPrice
          : "0", // 优惠金额
        souCourseName: this.formData.souCourseName,
      };

      // for (const key in obj) {
      //     if ((!obj[key] || obj[key].length === 0) && key !== 'custodianName' && key !== 'custodianPhone' && key !== 'custodianIdCard' && key !== 'psnAccount' && key !== 'idCard') {
      //         delete obj[key]
      //     }
      // }

      this.disabledButton = true;
      setFinanceContract(delNullProperty(obj))
        .then((data) => {
          this.$message.success(`新建成功`);
          this.formLoading = false;
          setTimeout(() => {
            this.closePage();
          }, 500);
        })
        .catch((err: Error) => {
          if (err) {
            this.disabledButton = false;
            this.formLoading = false;
          }
          if (err.message === "审批流报错") {
            this.errorDialogShow = true;
          }
        });
    });
  }

  choiceContractTemplate(val) {
    if (!val) {
      return;
    }
    this.$set(this.formData, "contractTemplateName", val);
    let contractHtml = null;
    this.contractTemplateList.map((item) => {
      if (val == item.name) {
        contractHtml = item.detail;
        this.contractDetail = item.detail;
      }
    });
    /*判断是否包含某几个字段*/
    if (
      contractHtml.length > 0 &&
      contractHtml.indexOf("公司名称") !== -1 &&
      contractHtml.indexOf("请输入公司统一社会信用代码") !== -1 &&
      contractHtml.indexOf("请输入公司地址") !== -1 &&
      contractHtml.indexOf("请输入姓名") !== -1 &&
      contractHtml.indexOf("请输入学生身份证") !== -1 &&
      contractHtml.indexOf("请输入学生手机号") !== -1 &&
      contractHtml.indexOf("请输入法定监护人姓名") !== -1 &&
      contractHtml.indexOf("请输入监护人身份证号码") !== -1 &&
      contractHtml.indexOf("请输入法定监护人手机号码") !== -1
    ) {
      const newStr = contractHtml.replace("公司名称", this.formData.company);
      const str1 = newStr.replace("请输入公司统一社会信用代码", this.code);
      const str2 = str1.replace("请输入公司地址", this.address);
      const str3 = str2.replace("请输入姓名", this.formData.customerName);
      const str4 = str3.replace(
        "请输入学生身份证",
        this.formData.idCard ? this.formData.idCard : "",
      );
      const str5 = str4.replace(
        "请输入学生手机号",
        this.formData.psnAccount ? this.formData.psnAccount : "",
      );

      const str6 = str5.replace(
        "请输入法定监护人姓名",
        this.formData.isAdult == "0" ? this.formData.custodianName : "",
      );
      const str7 = str6.replace(
        "请输入监护人身份证号码",
        this.formData.isAdult == "0"
          ? this.formData.custodianIdCard
            ? this.formData.custodianIdCard
            : ""
          : "",
      );
      const str8 = str7.replace(
        "请输入法定监护人手机号码",
        this.formData.isAdult == "0" ? this.formData.custodianPhone : "",
      );
      let str9;
      if (Number(this.formData.discountPrice) > 0) {
        const newMoney = math.number(
          math.subtract(
            math.bignumber(Number(this.formData.souCoursePrice)),
            math.bignumber(Number(this.formData.discountPrice)),
          ),
        );

        str9 = str8.replaceAll(
          "{{优惠金额}}",
          "，项目优惠金额" +
            this.formData.discountPrice +
            "元人民币/人，本协议约定项目费用共计" +
            newMoney +
            "元人民币/人",
        );
      } else {
        str9 = str8.replaceAll("{{优惠金额}}", "");
      }
      // 备注替换字段
      let str10;
      if (this.templateRemark) {
        str10 = str9.replaceAll(
          "{{备注}}",
          '<p style="white-space: pre-wrap;">' + this.templateRemark + "</p>",
        );
      } else {
        str10 = str9.replaceAll("{{备注}}", "");
      }
      // 项目金额替换字段
      str10 = str10.replaceAll("{{项目金额}}", this.formData.souCoursePrice);

      // 收款账户替换字段
      let str11 = "";
      const accountObj =
        "<p>账户名称：" +
        this.accountObj.name +
        "</p>" +
        "<p>收款人地址：" +
        this.accountObj.address +
        "</p>" +
        "<p>账户号：" +
        this.accountObj.bankAccount +
        "</p>" +
        "<p>开户银行：" +
        this.accountObj.bank +
        "</p>" +
        "<p>银行行号：" +
        this.accountObj.bankCode +
        "</p>";
      str11 = str10.replaceAll("{{收款账户}}", accountObj);

      // 查询是否存在'负责人姓名及手机号：'
      if (str11.indexOf("<td>负责人姓名及手机号：") !== -1) {
        str11 = str11.replace("<td>负责人姓名及手机号：", "<td> ");
      }

      this.contractTemplateDetail = str11;

      this.$nextTick(() => {
        const str11 = this.formData.contractAt[0];
        const arr22 = str11.split("-");
        document.getElementById("companySign").innerHTML =
          this.formData.company;

        if (this.formData.isAdult === "1") {
          // 成年直接签字（图片类型）
          // document.getElementById('nameSign').innerHTML = ''
          // document.getElementById('guardianNameSign').innerHTML =  this.formData.custodianName;
          document.getElementById("guardianNameSign").innerHTML = "";
        } else {
          document.getElementById("nameSign").innerHTML =
            this.formData.customerName;
        }

        if (
          !this.souCourseSchoolBegin ||
          this.souCourseSchoolBegin == "暂未设置开课时间"
        ) {
          this.souCourseSchoolBegin =
            this.formData.souCourseSchoolBegin &&
            this.formData.souCourseSchoolBegin.length > 0
              ? this.formData.souCourseSchoolBegin[0]
              : "";
        }
        // 兼容没有开课时间的项目
        if (
          this.souCourseSchoolBegin &&
          this.souCourseSchoolBegin !== "暂未设置开课时间"
        ) {
          const arr = this.souCourseSchoolBegin.split("/");
          // 如果是国外小组科研或者海外导师线下项目，在项目名称前面增加导【导师：】
          if (
            this.formData.souCourseType == "1" ||
            this.formData.souCourseType == "38"
          ) {
            document.getElementById("projectName").innerHTML =
              "【导师：" +
              this.projectDialogCheckedTable.souTeacherName +
              "】" +
              this.formData.souCourseName +
              "【开课时间：" +
              arr[0] +
              "年" +
              arr[1] +
              "月" +
              arr[2] +
              "日" +
              "】";
          } else {
            document.getElementById("projectName").innerHTML =
              this.formData.souCourseName +
              "【开课时间：" +
              arr[0] +
              "年" +
              arr[1] +
              "月" +
              arr[2] +
              "日" +
              "】";
          }
        } else {
          if (
            this.formData.souCourseType == "1" ||
            this.formData.souCourseType == "38"
          ) {
            document.getElementById("projectName").innerHTML =
              "【导师：" +
              this.projectDialogCheckedTable.souTeacherName +
              "】" +
              this.formData.souCourseName;
          } else {
            document.getElementById("projectName").innerHTML =
              this.formData.souCourseName;
          }
        }

        // let directorUserName;
        // this.userList.forEach(item => {
        //     if (this.formData.directorUserId == item.id) {
        //         directorUserName = item.realName
        //     }
        // });
        // document.getElementById('conpanyFlagSign').innerHTML = directorUserName ? directorUserName : '';
        (document.getElementById("imgContract") as HTMLFormElement).src =
          this.contractUrl;
        document.getElementById("jiaYear").innerHTML = arr22[0];
        document.getElementById("jiaMonth").innerHTML = arr22[1];
        document.getElementById("jiaDay").innerHTML = arr22[2];
        /*20250902 需求 生成的合同删除负责人和手机号字段*/
        // if (document.getElementById('directorName')) document.getElementById('directorName').innerHTML = this.formData.directorUserName + ' ' + this.directorUserPhone

        const html = document.getElementById("contractTem").outerHTML;
        this.contractTemplateDetail = html + this.pushHtmlStr;
      });
    }
  }

  /*编辑保存*/
  clickEditSubmitButton() {
    let newHtml = "";
    let flag = true;
    (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
      if (!valid) {
        flag = false;
        return;
      }
    });
    if (!this.formData.contractTemplateName.trim()) {
      this.$message.error("请选择合同模板");
      return;
    }

    // this.contractOpenUrl = this.contractOpenUrl.replace('.pdf', '.txt')
    if (flag) {
      // axios.get(this.contractOpenUrl).then((ress: any) => {
      newHtml = this.contractTemplateDetail;
      const oldHtml = this.contractTemplateDetail;
      const arr22 = this.formData.contractAt[0].split("-");

      const res = oldHtml.match(/\lass="idCard">.*?<b>/g);
      const res1 = oldHtml.match(/\id="phone">.*?\<\/u>/g);
      const res2 = oldHtml.match(/\id="guardianName">.*?\<\/u>/g);
      const res3 = oldHtml.match(/\id="guardianIdCard">.*?\<\/u>/g);
      const res4 = oldHtml.match(/\id="guardianPhone">.*?\<\/u>/g);
      const res5 = oldHtml.match(/\id="jiaYear">.*?\<\/u>/g);
      const res6 = oldHtml.match(/\id="jiaMonth">.*?\<\/u>/g);
      const res7 = oldHtml.match(/\id="jiaDay">.*?\<\/u>/g);
      const res8 = oldHtml.match(
        /\id="guardianNameSign" style="display: none; width: 30%;"><img src=".*?\id="guardianNameSignImg"/g,
      );
      const res9 = oldHtml.match(
        /\id="nameSign" style="display: none; width: 30%;"><img src=".*?\id="nameSignImg"/g,
      );

      newHtml = newHtml.replace(
        res[0],
        'lass="idCard">' +
          (this.formData.idCard ? this.formData.idCard : "") +
          "<b>",
      );
      newHtml = newHtml.replace(
        res1,
        'id="phone">' +
          (this.formData.psnAccount ? this.formData.psnAccount : "") +
          "</u>",
      );
      newHtml = newHtml.replace(
        res2,
        'id="guardianName">' +
          (this.formData.isAdult == "0"
            ? this.formData.custodianName
              ? this.formData.custodianName
              : ""
            : "") +
          "</u>",
      );
      newHtml = newHtml.replace(
        res3,
        'id="guardianIdCard">' +
          (this.formData.isAdult == "0"
            ? this.formData.custodianIdCard
              ? this.formData.custodianIdCard
              : ""
            : "") +
          "</u>",
      );
      newHtml = newHtml.replace(
        res4,
        'id="guardianPhone">' +
          (this.formData.isAdult == "0"
            ? this.formData.custodianPhone
              ? this.formData.custodianPhone
              : ""
            : "") +
          "</u>",
      );
      newHtml = newHtml.replace(res5, 'id="jiaYear">' + arr22[0] + "</u>");
      newHtml = newHtml.replace(res6, 'id="jiaMonth">' + arr22[1] + "</u>");
      newHtml = newHtml.replace(res7, 'id="jiaDay">' + arr22[2] + "</u>");

      if (this.formData.isAdult === "1") {
        // 成年直接签字（图片类型）
        newHtml = newHtml.replace(
          res8,
          'id="guardianNameSign" style="display: none; width: 30%;"><img src="' +
            "" +
            '"' +
            'id="guardianNameSignImg"',
        );
      } else {
        newHtml = newHtml.replace(
          res9,
          'id="nameSign" style="display: none; width: 30%;"><img src="' +
            this.formData.customerName +
            '" id="nameSignImg"',
        );
      }
      this.formLoading = true;
      generatePdf({
        htmlStr: newHtml,
        marginTop: 80,
        marginBottom: 80,
      }).then((res: any) => {
        this.formData.contractUrl = res.url;
        this.formLoading = false;

        // 校验
        const flagIsAdult = this.types == "0" && this.formData.isAdult == "1";
        const obj = {
          id: this.contractId,
          directorUserId: this.formData.directorUserId,
          isAdult: this.formData.isAdult,
          custodianName: !flagIsAdult ? this.formData.custodianName.trim() : "", // 监护人姓名 // 当types = '0'时且isAdult = '0'时必需
          custodianPhone: !flagIsAdult ? this.formData.custodianPhone : "",
          custodianIdCard: !flagIsAdult ? this.formData.custodianIdCard : "",
          contractAt: this.changeTime(this.formData.contractAt as Date[]),
          psnAccount: this.formData.psnAccount,
          idCard: this.formData.idCard,
          url: this.formData.contractUrl,
          company: this.formData.company,
          souCourseName: this.formData.souCourseName,
          souCoursePrice: this.formData.souCoursePrice,
          discountPrice: String(this.formData.discountPrice),
          commissionType: this.formData.commissionType,
          priceOrRatio: this.formData.priceOrRatio
            ? this.formData.priceOrRatio
            : "",
          dissertationType: this.formData.dissertationType,
          projectAllId: this.formData.projectAllId,
        };

        // for (const key in obj) {
        //     if ((!obj[key] || obj[key].length === 0) && key !== 'custodianName' && key !== 'custodianPhone' && key !== 'custodianIdCard' && key !== 'psnAccount' && key !== 'idCard') {
        //         delete obj[key]
        //     }
        // }

        this.formLoading = true;
        this.disabledButton = true;

        setFinanceContractByIdAndTypes(obj)
          .then((res) => {
            this.$message.success("保存成功，页面即将关闭");
            setTimeout(() => {
              this.closePage();
            }, 500);
            this.formLoading = false;
          })
          .catch((err) => {
            if (err.message === "审批流报错") {
              this.errorDialogShow = true;
            }
            this.disabledButton = false;
            this.formLoading = false;
          });
      });
      // })
    }
  }

  choiceStudent(e) {
    this.studentDialogPage = 1;
    this.studentDialogInputValue = "";
    this.studentDialog = true;
    // this.getFinanceOrderMarketCooperationList()
    e.target.blur();
  }

  handlePreview(file) {
    if (file.response) {
      this.previewPath = file.response.data.url;
    } else {
      this.previewPath = file.url;
    }
    this.previewName = file.name;
    this.previewVisible = true;
  }

  fileExtension(type: any) {
    if (type) {
      return type.substring(type.lastIndexOf(".") + 1);
    }
  }

  handleUploadRemove(file) {
    this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
  }

  closePage() {
    window.close();
  }

  // 所属公司列表
  async getCompanyList() {
    const data: any = await getCompanyList({ isContract: true });
    this.companyList = data.companyList;
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return "";
    let time = "";
    val.forEach((item: any) => {
      time += formatDate("yyyy-MM-dd", new Date(item)) + "&";
    });
    time = time.slice(0, time.length - 1);
    return time;
  }

  async getCustomerList() {
    const data: any = await getCustomerList({
      limit: this.customerNameLimit,
      customerName: this.name,
    });
    this.customerList = [...this.customerList, ...data.customerList];
    const result = [];
    const obj = {};
    for (let i = 0; i < this.customerList.length; i++) {
      if (!obj[this.customerList[i].customerId]) {
        result.push(this.customerList[i]);
        obj[this.customerList[i].customerId] = true;
      }
    }
    this.customerList = result;
  }

  async getFoucsCustomerList() {
    if (this.customerList.length == 0 && !this.formData.customerName) {
      this.name = "";
      this.customerNameLimit = 20;
      const result: any = await getCustomerList({
        limit: this.customerNameLimit,
        customerName: this.name,
      });
      this.customerList = result.customerList;
    }
    if (this.formData.customerName) {
      this.customerList = [];
      this.customerNameLimit = 20;
      const result: any = await getCustomerList({
        limit: this.customerNameLimit,
        customerName: this.formData.customerName,
      });
      this.customerList = result.customerList;
    }
  }

  clearCustomerList(e) {
    if (!this.formData.customerName) {
      this.name = "";
      this.customerNameLimit = 20;
      this.getCustomerList();
    }
  }

  async remoteMethod(query: any) {
    this.name = query;
    this.customerNameLimit = 20;
    if (query !== "") {
      const result: any = await getCustomerList({
        limit: this.customerNameLimit,
        customerName: this.name,
      });
      this.customerList = result.customerList;
    } else {
      this.customerList = [];
      this.getCustomerList();
    }
  }

  clearCustomer() {
    this.formData.customerName = "";
    this.name = "";
    this.customerNameLimit = 20;
    this.getCustomerList();
  }

  customerChange(val) {
    this.isSyncIEPQ = false
    this.formData.isAdult = "1";
    this.formData.idCard = "";
    this.formData.custodianName = "";
    this.formData.custodianIdCard = "";
    this.formData.custodianPhone = "";
    this.pushHtmlStr = "";
    this.formData.customerName = val.customerName;
    this.formData.customerId = val.customerId;
    this.formData.sourceType = val.customerSourceType == "合作伙伴" ? "1" : "0"; // 普通来源或者合作伙伴
    this.formData.source = val.customerSource;
    if (val) {
      this.customerInfo = this.customerList.filter(
        (item) =>
          item.customerId === val.customerId &&
          item.customerType === val.customerType,
      )[0];
    } else {
      this.formData.souCourseName = "";
      this.customerInfo = {
        customerId: undefined,
        customerName: "",
        customerSource: "",
        customerSourceType: "",
        customerType: "",
        marketCooperationId: undefined,
      };
    }
  }

  loadmore() {
    this.customerNameLimit += 20;
    if (this.customerNameLimit == 100) {
      return;
    }
    this.getCustomerList();
  }

  handleFocus() {
    this.getFinanceContractTemplate();
  }

  async getFinanceContractTemplate() {
    if (!this.formData.dissertationType) {
      this.$message.error("论文服务类型不可为空");
      return;
    }
    if (!this.formData.souCourseType) {
      this.$message.error("项目类型不可为空");
      return;
    }
    // 2024-09-20 项目类型为国内1v1 国外1v1 竞赛1v1的时候 价格不必填
    if (
      !this.formData.souCoursePrice &&
      this.formData.souCourseType != "2" &&
      this.formData.souCourseType != "3" &&
      this.formData.souCourseType != "40"
    ) {
      this.$message.error("请选择项目价格");
      return;
    }
    if (!this.formData.company) {
      this.$message.error("所属公司不可为空");
      return;
    }
    if (!this.formData.contractAt) {
      this.$message.error("合同签订期限不可为空");
      return;
    }
    const price =
      this.formData.souCourseType != "2" &&
      this.formData.souCourseType != "3" &&
      this.formData.souCourseType != "40"
        ? this.formData.souCoursePrice
        : "";
    const { financeContractTemplateList }: any =
      await getFinanceContractTemplate(
        delNullProperty({
          dissertationType: this.formData.dissertationType,
          souCoursePrice: price,
          souCourseTypeId: Number(this.formData.souCourseType),
          companyName: this.formData.company,
        }),
      );

    if (financeContractTemplateList) {
      this.contractTemplateList = financeContractTemplateList;
    }
  }

  changeDirectorUserId(e) {
    this.formData.directorUserId = e.id;
    if (e.id) {
      this.formData.directorUserName = e.realName;
      this.formData.deparment = e.departmentName;
      this.directorUserPhone = e.phone;
      if (this.batchSignInfoData.length > 0)
        this.batchSignInfoData.forEach((item) => {
          item.directorUserRealName = e.realName;
          item.directorUserPhone = e.phone;
          item.directorUserId = e.id;
        });
      if (this.formData.contractTemplateName) {
        this.choiceContractTemplate(this.formData.contractTemplateName);
      }
    }
  }

  @Watch("userId")
  handledirectorUserId(userId: string) {
    if (!this.formData.directorUserId && !this.contractId) {
      // 新建
      this.formData.directorUserId = userId;
    }
  }

  @Watch("userName")
  handledirectorUserName(userName: string) {
    if (!this.formData.directorUserName && !this.contractId) {
      // 新建
      this.formData.directorUserName = userName;
    }
  }

  @Watch("userPhone")
  handledirectorUserPhone(userPhone: string) {
    if (
      this.formData.directorUserId == this.userId &&
      !this.directorUserPhone &&
      !this.contractId
    ) {
      // 新建
      this.directorUserPhone = userPhone;
    }
  }

  @Watch("department")
  handleChangeDepartment(department: string) {
    if (
      !this.formData.deparment &&
      this.formData.directorUserId == this.userId
    ) {
      this.formData.deparment = department;
    }
  }

  @Watch("intentionProjectSelected", { deep: true })
  handleChangeDisabled(val, oVal) {
    if (val !== oVal) {
      // 选中当前行 将当前行的disable属性置灰
      this.projectDialogTableData.forEach((item, currentIndex) => {
        item.disabled = true;
        val.forEach((i) => {
          if (item.projectAllId !== i.projectAllId) {
            // this.$set(this.projectDialogTableData[currentIndex], 'radio', '0');
            this.$set(
              this.projectDialogTableData[currentIndex],
              "radio",
              item.souCourseName.indexOf(`\n`) !== -1
                ? item.souCourseName.split(`\n`)[0]
                : item.souCourseName,
            );
          }
        });
      });
      val[0].disabled = false;
    }
  }

  @Watch("formData.company", { deep: true })
  handleChangeCompany(val, oval) {
    if (val !== oval) {
      this.companyList.forEach((item) => {
        if (val == item.name) {
          this.address = item.address;
          this.code = item.code;
          this.contractUrl = item.contractUrl;
        }
      });
    }
  }

  changeCompany(e) {
    this.companyList.forEach((item) => {
      if (e == item.name) {
        this.accountObj = item;
      }
    });
    //     清空模板
    this.formData.contractTemplateName = "";
  }

  changeStudentContractList(val) {
    this.batchSignInfoData.forEach((item) => {
      if (val == item.customerId) {
        this.formData.customerName = item.customerName;
        this.formData.customerId = item.customerId;
        this.formData.source = item.customerSource;
        this.formData.isAdult = item.isAdult == "是" ? "1" : "0";
        this.formData.idCard = item.idCard;
        this.formData.psnAccount = item.psnAccount
          ? String(item.psnAccount)
          : "";
        this.formData.sourceType = item.customerSourceType;
        this.formData.directorUserId = item.directorUserId;
        this.formData.directorUserName = item.directorUserRealName;
        this.directorUserPhone = item.directorUserPhone;
        this.formData.deparment = item.directorDepartmentlName;
        if (this.formData.isAdult == "0") {
          this.formData.custodianName = item.custodianName;
          this.formData.custodianIdCard = item.custodianIdCard;
          this.formData.custodianPhone = item.custodianPhone
            ? String(item.custodianPhone)
            : "";
        }
        // if (this.formData.directorUserId) {
        // this.formData.dissertationType = '无'
        // this.formData.contractAt = [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")]
        // this.formData.directorUserId = item.directorUserId // 负责人id
        // this.formData.directorUserName = item.directorUserRealName // 负责人
        // }

        this.customerInfo = {
          customerId: Number(item.customerId),
          customerName: item.customerName,
          customerSource: String(decodeURI(item.customerSource as any)),
          customerSourceType: item.customerSourceType == "合作伙伴" ? "1" : "0",
          customerType: item.customerType as any,
          marketCooperationId: Number(item.marketCooperationId),
        };
        this.isReadonly = true;
      }
    });
    if (this.formData.souCourseName) {
      this.getFinancOrder(); // 查询订单
    }

    if (this.formData.contractTemplateName) {
      this.choiceContractTemplate(this.formData.contractTemplateName);
    }
  }

  changeContractAt() {
    if (this.formData.contractAt && this.formData.contractAt.length > 0) {
      this.choiceContractTemplate(this.formData.contractTemplateName);
    }
  }

  // 同步回访系统相关
  createAxios() {
    const origin = location.hostname;
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_SYNC_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_SYNC_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_SYNC_API;
      }
    }
    const config = {
      baseURL: requestBase,
      withCredentials: true,
      timeout: 30 * 1000,
      headers: { "Content-Type": "application/json" },
    };
    this.axios = axios.create(config);
  }

  async handleSyncIEPQ() {
    if (this.isSyncIEPQ === false) {
      // 清空
      this.pushHtmlStr = "";
      this.formData.isAdult = '1';
      this.formData.idCard = '';
      this.formData.custodianName = '';
      this.formData.custodianIdCard = '';
      this.formData.custodianPhone = '';
      return;
    }
    this.createAxios();
    // const customNo = "KH-B-20260520165919571";
    const customNo = this.customNo;
    const signStr = `customNo=${customNo}&key=MYwxaNRegZmrqieUAzci`;
    const sign = md5(signStr).toUpperCase();

    try {
      const res: any = await this.axios.post(
        "/sync/v1/student/studentRegister",
        { customNo },
        { params: { sign } },
      );
      if (res.data.code === 200) {
        // 返显默认数据
        const data = res.data.data;
        this.formData.isAdult = String(data.isAdult);
        this.formData.idCard = data.studentIdCard;
        this.formData.custodianName = data.guardianName;
        this.formData.custodianIdCard = data.guardianIdCard;
        this.formData.custodianPhone = data.guardianMobile;
        this.pushHtmlStr = data.htmlContent;
      } else {
        this.$message.error(res.data.msg);
        this.isSyncIEPQ = false;
      //   清空刚才的赋值
        this.formData.isAdult = "1";
        this.formData.idCard = "";
        this.formData.custodianName = "";
        this.formData.custodianIdCard = "";
        this.formData.custodianPhone = "";
        this.pushHtmlStr = "";
      }
    } catch (err) {
      this.isSyncIEPQ = false;
    }
  }
}
